import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { Component, NgZone, OnDestroy, OnInit, AfterViewInit, ElementRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MasterRolePermission } from '../Models/master-role-permission';
import { MasterFastagReconciliation } from '../Models/master-fastag-reconciliation';
import { SELECT_FASTAG_RECONCILATION } from '../Models/Report/SELECT_FASTAG_RECONCILATION';
import { ReportApiService } from '../ApiServices/report-api.service';
import { IdList, ReportParameters } from '../Models/report-parameters';
import { DeviceService } from '../ApiServices/device.service';

import * as $ from 'jquery';
import { exit } from 'node:process';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-fastag-reconciliation',
  templateUrl: './fastag-reconciliation.component.html',
  styleUrls: ['./fastag-reconciliation.component.css'],
  animations: [
    trigger('widthGrow', [
      state('closed', style({
        width: 0,
        display: 'none'
      })),
      state('open', style({
        width: 720,
        display: 'block'
      })),
      transition('* => *', animate(200))
    ]),
  ]
})
export class FastagReconciliationComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document, private elementRef: ElementRef, private router: Router, private reportApiService: ReportApiService, private deviceService: DeviceService) { }

  fromDate: string = '';
  toDate: string = '';
  vehicleNumber: string = '';
  SELECT_FASTAG_RECONCILATION_LIST: SELECT_FASTAG_RECONCILATION[] = [];
  reportParameters: ReportParameters;
  masterFastagReconciliationObj: MasterFastagReconciliation;
  operationNumber: number = 0;
  reason: string = '';

  ngOnInit(): void {
    var token = sessionStorage.getItem('token');
    if (token == null) {
      this.router.navigateByUrl('/');
      return;
    } else {
      if (sessionStorage.getItem("ROLE_PERMISSIONS").toString().indexOf(MasterRolePermission.ViewANPRViewStreaming.rolePermission) < 0) {
        alert("Unauthorised access");
        this.router.navigateByUrl('/index');
        return;
      } else {

      }
    }

    var now = new Date();
    this.fromDate = now.getDate() + '-' + (now.getMonth() + 1) + '-' + now.getFullYear() + ' ' + now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds();
    this.toDate = this.fromDate;
  }

  SearchData() {
    this.reportParameters = new ReportParameters();
    this.reportParameters.fromdate = this.fromDate;
    this.reportParameters.todate = this.toDate;
    this.reportParameters.vehicleNumber = this.vehicleNumber;
    this.SELECT_FASTAG_RECONCILATION_LIST = [];
    this.reportApiService.SELECT_FASTAG_RECONCILATION_LIST(this.reportParameters).subscribe(w => {
      this.SELECT_FASTAG_RECONCILATION_LIST = w;
    })
  }

  KnockOff(OPERATION_NUMBER) {
    this.operationNumber = parseInt(OPERATION_NUMBER);
    this.reason = (<HTMLInputElement>document.getElementById('remark' + OPERATION_NUMBER)).value;
    $('#KnockOffModalButton').click();
  }
  KnockOffYes() {
    this.masterFastagReconciliationObj = new MasterFastagReconciliation();
    this.masterFastagReconciliationObj.OPERATION_NUMBER = this.operationNumber;
    this.masterFastagReconciliationObj.REMARK = this.reason;
    this.deviceService.KnockOff(this.masterFastagReconciliationObj).subscribe((resp) => {
      this.SearchData();
    }, (err) => {
    });
  }
}
